<template>
  <div class="row align-items-center border-bottom border-bottom-1 border-gray-200 py-10">
    <Select2
        container-class="form-group col-12 col-md-5 mb-7"
        :multiple="false"
        :show-search="true"
        :selectClass="'form-select form-control-sm form-select-solid'"
        :name="`payslip-allowance-`+id"
        :label="$t('payslip.label.title')"
        labelClass="form-label fs-6 text-black"
        :placeholder-text="$t('payslip.label.title')"
        @update:modelValue="toggleEdited"
        v-model="allowanceData.id"
        :parent-id="parentId && '#'+parentId"
        :IsInputGroup="$can(abilities.CREATE_ALLOWANCE)"
        icon="bi bi-plus"
        :clickAddon="openAllowanceModal">
      <option v-for="allowance in allowances" :value="allowance.id" :key="allowance.id">
        {{ allowance.title }}
      </option>
    </Select2>

    <InputAmount
        containerClass="col-12 col-md-5 mb-7"
        :label="$t('payslip.label.amount')"
        labelClass="form-label fs-6 text-black"
        :inputClass="'form-control form-control-solid'"
        :number="allowanceData.value"
        :iso="currency"
        :required="true"
        @keyup="handleEdited"
        @amount="(val) => allowanceData.value = val"/>

    <div class="col-2">
      <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="deleteAllowanceRow(index)">
        <i class="bi bi-trash-fill fs-5"></i>
      </a>
    </div>
  </div>

  <NewAllowanceModal :id="'allowance-create-modal'+id" @reloadDatatable="reloadAllowances" />
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, onMounted, ref, watch} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import NewAllowanceModal from "@/Modules/RH/views/Setting/allowance/components/NewAllowanceModal.vue";
import {calculatePayslipItemValue} from "@/mixins/Helpers";
import abilities from "@/composables/abilities";
import InputAmount from "@/components/InputAmount.vue";

const store = useStore()
const emits = defineEmits(["deleteRow"])
const props = defineProps({
  parentId: String,
  baseSalary: "",
  allowance: {
    type: Object,
    default: () => ({
      id: '',
      edited: false,
      value: 0
    })
  },
  currency: String,
  index: Number,
  id: String,
})



const allowanceData = ref(props.allowance)

const allowances = computed(() => store.getters['allowances/getAllowances'])

const selectedAllowanceData = computed(() => {
  if(!allowanceData.value.id) return null
  return allowances.value.find(al => al.id === allowanceData.value.id)
})


const calcSalaryWithAllowance = (salary, allowance) => {
  if (!salary) return 0
  if(!allowance) return 0
  const allowanceData = allowance?.data.map?.(al => ({
    range_max: parseFloat(al?.range_max) || 0,
    range_min: parseFloat(al?.range_min) || 0,
    type: al.type,
    value: parseFloat(al.value) || 0
  }))
  return calculatePayslipItemValue(parseFloat(props.baseSalary), allowanceData)
}

watch(() => [props.baseSalary, allowanceData.value.id], () => {

  handleChange()
}, { deep: true })

const handleChange = () => {

  if(!allowanceData.value.edited) {
    allowanceData.value.value = calcSalaryWithAllowance(props.baseSalary, selectedAllowanceData.value)
  }
}

const toggleEdited = () => {
  allowanceData.value.edited = false
}
const handleEdited = () => {
  allowanceData.value.edited = true
}

const openAllowanceModal = () => {
  $('#allowance-create-modal'+props.id).modal('toggle')
}

function deleteAllowanceRow(index) {
  emits('deleteRow', index)
}

function reloadAllowances() {
  store.dispatch('allowances/loadAllowances')
}

onMounted(() => {
  handleChange()
})

</script>

<style scoped>
</style>
